import { useLang } from "@/i18n";

export const inputCls =
  "w-full border border-[#e8e8e8] rounded-sm px-3.5 py-2.5 text-sm text-[#000000] bg-white focus:outline-none focus:border-[#dd260e] transition-colors placeholder:text-[#aaaaaa]";

export const Field = ({ label, required, hint, error, children, testId }) => {
  const { t } = useLang();
  return (
    <div data-testid={testId}>
      <label className="block text-[11px] font-bold uppercase tracking-[0.12em] text-[#000000] mb-1.5">
        {t(label)} {required && <span className="text-[#dd260e]">*</span>}
      </label>
      {children}
      {hint && !error && <p className="text-[11px] text-[#999999] mt-1.5">{t(hint)}</p>}
      {error && (
        <p className="text-[11px] text-[#dd260e] font-semibold mt-1.5" data-testid={testId ? `${testId}-error` : undefined}>
          {t(error)}
        </p>
      )}
    </div>
  );
};

export const TextInput = ({ error, placeholder, ...props }) => {
  const { t } = useLang();
  return <input className={`${inputCls} ${error ? "border-[#dd260e]" : ""}`} placeholder={placeholder ? t(placeholder) : placeholder} {...props} />;
};

export const TextArea = ({ error, placeholder, ...props }) => {
  const { t } = useLang();
  return <textarea className={`${inputCls} min-h-[96px] resize-y ${error ? "border-[#dd260e]" : ""}`} placeholder={placeholder ? t(placeholder) : placeholder} {...props} />;
};

export const SelectInput = ({ options, placeholder, error, ...props }) => {
  const { t } = useLang();
  return (
    <select className={`${inputCls} ${error ? "border-[#dd260e]" : ""} ${!props.value ? "text-[#aaaaaa]" : ""}`} {...props}>
      {placeholder && <option value="">{t(placeholder)}</option>}
      {options.map((o) => (
        <option key={o} value={o}>
          {t(o)}
        </option>
      ))}
    </select>
  );
};
